import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json";
import { dateToStringDate } from "../Helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Sarana() {
  // State untuk sarana2
  const url_list2 = Config.api_domain + "/sarana2/active/";
  const [list2, setList2] = useState([]);

  useEffect(() => {
    const fetchData2 = async () => {
      try {
        const res = await fetch(url_list2, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList2(data.data || []);
      } catch (error) {
        console.error("Fetch error sarana2:", error.message);
      }
    };
    fetchData2();
  }, [url_list2]);

  // State untuk sarana1
  const url_list1 = Config.api_domain + "/sarana1/active/";
  const [list1, setList1] = useState([]);

  useEffect(() => {
    const fetchData1 = async () => {
      try {
        const res = await fetch(url_list1, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList1(data.data || []);
      } catch (error) {
        console.error("Fetch error sarana1:", error.message);
      }
    };
    fetchData1();
  }, [url_list1]);

  // State untuk sarana (original)
  const url_list = Config.api_domain + "/sarana/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

  function getRows2() {
    if (list2 && list2.length > 0) {
      return list2.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={
                  Config.api_domain +
                  "/sarana2/download/" +
                  row.public_id
                }
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data-2">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  function getRows1() {
    if (list1 && list1.length > 0) {
      return list1.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={
                  Config.api_domain +
                  "/sarana1/download/" +
                  row.public_id
                }
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data-1">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  function getRows() {
    if (typeof list !== "undefined" && list !== null && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/sarana/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        <h2>Paket Pengadaan Sarana Pusat Pengembangan Kompetensi</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          Badan Informasi Geospasial (BIG) merupakan koordinator utama penyelenggaraan informasi geospasial di Indonesia. BIG tidak hanya bertanggung jawab untuk memastikan ketersediaan data geospasial yang akurat dan dapat diakses, tetapi juga membangun kapasitas SDM yang mampu memanfaatkan data tersebut secara efektif. Untuk memenuhi kebutuhan ini, Pusat Pengembangan Kompetensi Informasi Geospasial (PPKIG) Badan Informasi Geospasial dituntut untuk meningkatkan kapasitasnya dalam melaksanakan pengembangan kompetensi SDM.
          <br /><br />
          Dalam melaksanakan tugas fungsinya menyediakan pelatihan yang berkualitas, PPKIG juga melengkapi dirinya dengan berbagai sarana, termasuk sarana mess. Mess tidak hanya berfungsi sebagai tempat istirahat, tetapi juga sebagai ruang pemulihan fisik dan mental peserta setelah menjalani kegiatan belajar yang intensif. Untuk mendukung fungsi mess pelatihan yang nyaman sehingga mampu memberi dukungan terhadap keberhasilan pelatihan, mess perlu dilengkapi dengan meja dan kursi makan bagi peserta pelatihan. Penyediaan meja dan kursi makan di mess pelatihan merupakan aspek penting dalam mendukung kenyamanan, kesehatan, dan efisiensi kegiatan peserta selama mengikuti pelatihan. Ketersediaan meja dan kursi makan yang memadai dan layak menjadi kebutuhan dasar yang tidak dapat diabaikan. Oleh karena itu, pada tahun 2025 ini, akan dilaksanakan Peningkatan Sarana Mess berupa pengadaan seperangkat meja dan kursi makan untuk melengkapi sarana mess pelatihan di PPKIG. Dalam konteks pengembangan kompetensi sumber daya manusia di bidang informasi geospasial, perpustakaan memiliki peran strategis sebagai penyedia sarana dan prasarana pembelajaran yang mendukung proses pelatihan dan pengembangan kompetensi, baik secara mandiri maupun dalam kelompok. Keberadaan perpustakaan sebagai pusat informasi, dokumentasi, dan literasi sangat penting untuk menunjang proses belajar yang berkelanjutan.
          <br /><br />
          Perpustakaan tidak hanya menyediakan koleksi buku dan referensi, tetapi juga bertransformasi menjadi ruang belajar aktif yang dilengkapi dengan fasilitas teknologi informasi, akses ke sumber daya digital, serta layanan bimbingan dan pelatihan literasi informasi. Fungsi ini menjadikan perpustakaan sebagai bagian integral dari ekosistem pelatihan dan pembelajaran di Pusat Pengembangan Kompetensi Informasi Geospasial. Untuk mendukung peran tersebut, perpustakaan perlu didukung dengan sarana dan fasilitas yang memadai.
        </p>

        <h3>Announcement (ULANG 2)</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="announcement2">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{getRows2()}</TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline (ULANG 2)</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}> 
  <Table sx={{ minWidth: 500 }} aria-label="timeline2">
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <StyledTableRow>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>Pengumuman Ulang RFQ pada website ILASP</StyledTableCell>
        <StyledTableCell>05 Nov 25</StyledTableCell>
        <StyledTableCell>12 Nov 25</StyledTableCell>
      </StyledTableRow>
      <StyledTableRow>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>Pemasukan Penawaran</StyledTableCell>
        <StyledTableCell>05 Nov 25 07.30 WIB (GMT+7)</StyledTableCell>
        <StyledTableCell>12 Nov 25 16.00 WIB (GMT+7)</StyledTableCell>
      </StyledTableRow>
      <StyledTableRow>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>Notification of Intention to Award</StyledTableCell>
        <StyledTableCell>18 Nov 25</StyledTableCell>
        <StyledTableCell>18 Nov 25</StyledTableCell>
      </StyledTableRow>
      <StyledTableRow>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>Award of Contract and Publication of Contract Award</StyledTableCell>
        <StyledTableCell>19 Nov 25</StyledTableCell>
        <StyledTableCell>25 Nov 25</StyledTableCell>
      </StyledTableRow>
    </TableBody>
  </Table>
</TableContainer>


        <h3>Announcement (ULANG)</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="announcement1">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{getRows1()}</TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline (ULANG)</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 500 }} aria-label="timeline1">
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell>1</StyledTableCell>
                <StyledTableCell>Pengumuman RFQ pada website ILASP</StyledTableCell>
                <StyledTableCell>22 Sep 25</StyledTableCell>
                <StyledTableCell>06 Oct 25</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>2</StyledTableCell>
                <StyledTableCell>Pemberian Penjelasan</StyledTableCell>
                <StyledTableCell>24 Sep 25 09.00 WIB (GMT+7)</StyledTableCell>
                <StyledTableCell>25 Sep 25 12.00 WIB (GMT+7)</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>3</StyledTableCell>
                <StyledTableCell>Pemasukan Dokumen Penawaran</StyledTableCell>
                <StyledTableCell>22 Sep 25</StyledTableCell>
                <StyledTableCell>06 Oct 25 12.00 WIB (GMT+7)</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>4</StyledTableCell>
                <StyledTableCell>Evaluasi Dokumen Penawaran</StyledTableCell>
                <StyledTableCell>06 Oct 25</StyledTableCell>
                <StyledTableCell>09 Oct 25</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>5</StyledTableCell>
                <StyledTableCell>Notification of Intention to Award</StyledTableCell>
                <StyledTableCell>10 Oct 25</StyledTableCell>
                <StyledTableCell>10 Oct 25</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>6</StyledTableCell>
                <StyledTableCell>Award of Contract and Publication of Contract Award</StyledTableCell>
                <StyledTableCell>11 Oct 25</StyledTableCell>
                <StyledTableCell>20 Oct 25</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{getRows()}</TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}> 
          <Table sx={{ minWidth: 500 }} aria-label="timeline table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell>1</StyledTableCell>
                <StyledTableCell>Pengumuman RFQ pada website ILASP</StyledTableCell>
                <StyledTableCell>25 Aug 2025</StyledTableCell>
                <StyledTableCell>08 Sep 2025</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>2</StyledTableCell>
                <StyledTableCell>Pemberian Penjelasan</StyledTableCell>
                <StyledTableCell>27 Aug 2025</StyledTableCell>
                <StyledTableCell>28 Aug 2025</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>3</StyledTableCell>
                <StyledTableCell>Pemasukan Dokumen Penawaran (UPDATED)</StyledTableCell>
                <StyledTableCell>25 Aug 2025</StyledTableCell>
                <StyledTableCell>15 Sep 2025 12:00 WIB (GMT+7)</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>4</StyledTableCell>
                <StyledTableCell>Evaluasi Dokumen Penawaran (UPDATED)</StyledTableCell>
                <StyledTableCell>15 Sep 2025</StyledTableCell>
                <StyledTableCell>18 Sep 2025</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>5</StyledTableCell>
                <StyledTableCell>Notification of Intention to Award (UPDATED)</StyledTableCell>
                <StyledTableCell>19 Sep 2025</StyledTableCell>
                <StyledTableCell>19 Sep 2025</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>6</StyledTableCell>
                <StyledTableCell>Award of Contract and Publication of Contract Award (UPDATED)</StyledTableCell>
                <StyledTableCell>20 Sep 2025</StyledTableCell>
                <StyledTableCell>29 Sep 2025</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>

       
      </Container>
    </div>
  );
}

export default Sarana;